export default {
      id: "i-search-icon-bold-usage",
      viewBox: "0 0 14 13",
      url: __webpack_public_path__ + "img/sprite.svg#i-search-icon-bold",
      toString: function () {
        return this.url;
      }
    }